import { render, staticRenderFns } from "./ItsStockFruitOutBoundSecondaryDetail.vue?vue&type=template&id=519ff262&scoped=true&"
import script from "./ItsStockFruitOutBoundSecondaryDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockFruitOutBoundSecondaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockFruitOutBoundSecondaryDetail.vue?vue&type=style&index=0&id=519ff262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ff262",
  null
  
)

export default component.exports